import {
  ADD_INTERVIEWER,
  ADD_INTERVIEWER_ERROR,
  ADD_INTERVIEWER_SUCCESS,
  GEN_OFFER_LETTER,
  GEN_OFFER_LETTER_FAILURE,
  GEN_OFFER_LETTER_SUCCESS,
  GET_EDIT_GEN_OFFER_LETTER_DETAILS,
  GET_EDIT_GEN_OFFER_LETTER_DETAILS_FAIL,
  GET_EDIT_GEN_OFFER_LETTER_DETAILS_SUCCESS,
  GET_GEN_OFFER_LETTER_DETAIL,
  GET_GEN_OFFER_LETTER_DETAIL_FAILURE,
  GET_GEN_OFFER_LETTER_DETAIL_SUCCESS,
  GET_HIRE_CANDIDATE,
  GET_HIRE_CANDIDATE_FAILURE,
  GET_HIRE_CANDIDATE_SUCCESS,
  GET_INTERVIEWERS,
  GET_INTERVIEWERS_ERROR,
  GET_INTERVIEWERS_SUCCESS,
  GET_INTERVIEW_ROUNDS,
  GET_INTERVIEW_ROUNDS_FAILURE,
  GET_INTERVIEW_ROUNDS_SUCCESS,
  HIRENEURON_VIDEO_INTEGRATION,
  HIRENEURON_VIDEO_INTEGRATION_FAIL,
  HIRENEURON_VIDEO_INTEGRATION_SUCCESS,
  OFFER_LETTER_TYPE,
  OFFER_LETTER_TYPE_FAILURE,
  OFFER_LETTER_TYPE_SUCCESS,
  POST_ABOUT_INTERVIEW,
  POST_INTERVIEW_DETAILS,
  POST_INTERVIEW_DETAILS_ERROR,
  POST_INTERVIEW_DETAILS_SUCCESS,
  RESCHEDULE_INTERVIEW,
  RESCHEDULE_INTERVIEW_FAILURE,
  RESCHEDULE_INTERVIEW_SUCCESS,
  SAVE_HIRE_CANDIDATE_DATA,
  SAVE_HIRE_CANDIDATE_DATA_FAILURE,
  SAVE_HIRE_CANDIDATE_DATA_SUCCESS,
  VIDEO_INTERVIEW,
} from "./actionTypes";

// send alllist true if want to  get all interviewer list for recruiter user.
// send alllist false and send jobId  if want to  get specific interviewer list for recruiter user
export const getInterviewersDetails = (jobId, allList) => {
  return {
    type: GET_INTERVIEWERS,
    payload: { jobId, allList },
  };
};
export const getInterviersDetailsFailed = (error) => {
  return {
    type: GET_INTERVIEWERS_ERROR,
    payload: { error },
  };
};
export const getInterviewerDetailsSuccess = (interviewerDetails) => {
  return {
    type: GET_INTERVIEWERS_SUCCESS,
    payload: interviewerDetails,
  };
};

export const postInterviewDetails = (scheduleObject) => {
  return {
    type: POST_INTERVIEW_DETAILS,
    payload: scheduleObject,
  };
};

export const postInterviewDetailsSuccess = (message) => {
  return {
    type: POST_INTERVIEW_DETAILS_SUCCESS,
    payload: message,
  };
};

export const postInterviewDetailsError = (error) => {
  return {
    type: POST_INTERVIEW_DETAILS_ERROR,
    payload: error,
  };
};

export const VideoInterview = (code) => {
  return {
    type: VIDEO_INTERVIEW,
    payload: code,
  };
};

export const addInterviewer = (obj) => {
  return {
    type: ADD_INTERVIEWER,
    payload: obj,
  };
};

export const addInterviewerSuccess = (message) => {
  return {
    type: ADD_INTERVIEWER_SUCCESS,
    payload: message,
  };
};

export const addInterviewerError = (error) => {
  return {
    type: ADD_INTERVIEWER_ERROR,
    payload: error,
  };
};

export const rescheduleInterview = (data) => {
  return {
    type: RESCHEDULE_INTERVIEW,
    payload: data,
  };
};

export const rescheduleInterrviewSuccess = (message) => {
  return {
    type: RESCHEDULE_INTERVIEW_SUCCESS,
    payload: message,
  };
};

export const rescheduleInterviewFailure = (error) => {
  return {
    type: RESCHEDULE_INTERVIEW_FAILURE,
    payload: error,
  };
};

export const postAboutInterview = (data) => {
  return {
    type: POST_ABOUT_INTERVIEW,
    payload: data,
  };
};

export const getInterviewRounds = (jobId) => {
  return {
    type: GET_INTERVIEW_ROUNDS,
    payload: { jobId },
  };
};
export const getInterviewRoundsFailed = (error) => {
  return {
    type: GET_INTERVIEW_ROUNDS_FAILURE,
    payload: { error },
  };
};
export const getInterviewRoundsSuccess = (rounds) => {
  return {
    type: GET_INTERVIEW_ROUNDS_SUCCESS,
    payload: rounds,
  };
};
export const getHireCandidateDetails = (jobId, candidateId) => {
  return {
    type: GET_HIRE_CANDIDATE,
    payload: { jobId, candidateId },
  };
};
export const getHireCandidateDetailsFailed = (error) => {
  return {
    type: GET_HIRE_CANDIDATE_FAILURE,
    payload: { error },
  };
};
export const getHireCandidateDetailsSuccess = (success) => {
  return {
    type: GET_HIRE_CANDIDATE_SUCCESS,
    payload: success,
  };
};

export const saveHireCandidateData = (data) => {
  return {
    type: SAVE_HIRE_CANDIDATE_DATA,
    payload: { data },
  };
};
export const saveHireCandidateDataFailed = (error) => {
  return {
    type: SAVE_HIRE_CANDIDATE_DATA_FAILURE,
    payload: { error },
  };
};
export const saveHireCandidateDataSuccess = (msg) => {
  return {
    type: SAVE_HIRE_CANDIDATE_DATA_SUCCESS,
    payload: msg,
  };
};

export const templateLetterList = (data) => {
  return {
    type: OFFER_LETTER_TYPE,
    payload: { data },
  };
};
export const offerLetterTypeListFailed = (error) => {
  return {
    type: OFFER_LETTER_TYPE_FAILURE,
    payload: { error },
  };
};
export const offerLetterTypeListSuccess = (list) => {
  return {
    type: OFFER_LETTER_TYPE_SUCCESS,
    payload: list,
  };
};

export const genOfferLetter = (data) => {
  return {
    type: GEN_OFFER_LETTER,
    payload: { data },
  };
};
export const genOfferLetterFailed = (error) => {
  return {
    type: GEN_OFFER_LETTER_FAILURE,
    payload: { error },
  };
};
export const genOfferLetterSuccess = (msg) => {
  return {
    type: GEN_OFFER_LETTER_SUCCESS,
    payload: { msg },
  };
};

export const getGenOfferLetterDetails = (jobId, candidateId) => {
  return {
    type: GET_GEN_OFFER_LETTER_DETAIL,
    payload: { jobId, candidateId },
  };
};
export const getGenOfferLetterDetailsFailed = (error) => {
  return {
    type: GET_GEN_OFFER_LETTER_DETAIL_FAILURE,
    payload: { error },
  };
};
export const getGenOfferLetterDetailsSuccess = (msg) => {
  return {
    type: GET_GEN_OFFER_LETTER_DETAIL_SUCCESS,
    payload: { msg },
  };
};

//add interview round

//verify hireneuron video meeting token
export const tokenVerify = (json) => {
  return {
    type: HIRENEURON_VIDEO_INTEGRATION,
    payload: { json },
  };
};

export const tokenVerifySuccess = (message) => {
  return {
    type: HIRENEURON_VIDEO_INTEGRATION_SUCCESS,
    payload: { message },
  };
};

export const tokenVerifyFail = (errormessage) => {
  return {
    type: HIRENEURON_VIDEO_INTEGRATION_FAIL,
    payload: { errormessage },
  };
};

//edit offer letter
export const revokeOfferDetails = (json) => {
  return {
    type: GET_EDIT_GEN_OFFER_LETTER_DETAILS,
    payload: { json },
  };
};

export const revokeOfferDetailsSuccess = (json) => {
  return {
    type: GET_EDIT_GEN_OFFER_LETTER_DETAILS_SUCCESS,
    payload: { json },
  };
};

export const revokeOfferDetailsFail = (json) => {
  return {
    type: GET_EDIT_GEN_OFFER_LETTER_DETAILS_FAIL,
    payload: { json },
  };
};
